import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Logo from '../../logo.jpeg'
import { Facebook, Instagram, Phone, Menu as MenuIcon, Home, Waves } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import Paths from '../../common/Paths'
import { Menu, MenuItem, styled } from '@mui/material'

const height = '50px'
const width = '75px'

const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  borderBottom: `.5px solid ${theme.palette.text.disabled}`
}))

const HideOnSmall = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  alignItems: 'center',
}))

const MenuItemWithIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  minWidth: '50px',
  alignItems: 'center',
  gap: '10px',
}))

const HomeIcon = styled(Home)(({ theme }) => ({
  width: '18px'
}))

const WavesIcon = styled(Waves)(({ theme }) => ({
  width: '18px'
}))

const PhoneIcon = styled(Phone)(({ theme }) => ({
  width: '18px'
}))

const InstagramIcon = styled(Instagram)(({ theme }) => ({
  width: '18px'
}))

const FacebookIcon = styled(Facebook)(({ theme }) => ({
  width: '18px'
}))

const ShowOnMobile = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}))

const HideOnMobile = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'flex-end',
}))

export default function ButtonAppBar() {
  const navigate = useNavigate()
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null)

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  }

  const onNavHome = () => navigate(Paths.home)

  const onNavServices = () => navigate(Paths.services)

  const onNavContact = () => navigate(Paths.contact)

  const onNavInstagram = () => openInNewTab('https://www.instagram.com/all_around_pool_cleaning')

  const onNavFacebook = () => openInNewTab('https://www.facebook.com/PoolCleaningAndMaintenance/')

  //get the current path and set the corresponding button to active
  const currentPath = window.location.pathname;
  const isActive = (path: string) => currentPath === path;

  return (
    <Box sx={{ flexGrow: 1, position: 'sticky', top: '0', backgroundColor: 'white', zIndex: 100 }}>
      <StyledAppBar position="static" color='transparent'>
        <Toolbar>
          <ShowOnMobile>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </ShowOnMobile>
          <img src={Logo} height={height} width={width} alt="card" />
          <Box component="div" sx={{ display: "flex", flexDirection: "row", flexGrow: 1, alignItems: 'center' }}>
            <Typography variant="h6" >
              All Around Pool Cleaning
            </Typography>
            <HideOnSmall>
              <Phone sx={{ ml: 4, mr: 1 }} />
              <Typography>0466400747</Typography>
            </HideOnSmall>
          </Box>
          <HideOnMobile>
            <Button 
              color={isActive(Paths.home) ? "secondary" : "inherit"} 
              onClick={onNavHome}
              variant={isActive(Paths.home) ? 'contained' : 'text'}
            >
              <Typography variant='buttonSmall'>
              Home
              </Typography>
            </Button>
            <Button 
              color={isActive(Paths.services) ? "secondary" : "inherit"}
              onClick={onNavServices}
              variant={isActive(Paths.services) ? 'contained' : 'text'}
            >
              <Typography variant='buttonSmall'>
              Services
              </Typography>
            </Button>
            <Button 
              color={isActive(Paths.contact) ? "secondary" : "inherit"} 
              onClick={onNavContact}
              variant={isActive(Paths.contact) ? 'contained' : 'text'}
            >
              <Typography variant='buttonSmall'>
              Contact
              </Typography>
            </Button>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="insta"
              sx={{ ml: 4 }}
              onClick={onNavInstagram}
            >
              <Instagram />
            </IconButton>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="facebook"
              sx={{ mr: 2 }}
              onClick={onNavFacebook}
            >
              <Facebook />
            </IconButton>
          </HideOnMobile>
        </Toolbar>
      </StyledAppBar>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{
          display: { xs: 'block', md: 'none' },
        }}
      >
        <MenuItem onClick={() => {
          onNavHome()
          handleCloseNavMenu()
        }}>
          <MenuItemWithIcon>
            <HomeIcon />
            <Typography textAlign="center">Home</Typography>
          </MenuItemWithIcon>
        </MenuItem>
        <MenuItem onClick={() => {
          onNavServices()
          handleCloseNavMenu()
        }}>
          <MenuItemWithIcon>
            <WavesIcon />
            <Typography textAlign="center">Services</Typography>
          </MenuItemWithIcon>
        </MenuItem>
        <MenuItem onClick={() => {
          onNavContact()
          handleCloseNavMenu()
        }}>
          <MenuItemWithIcon>
            <PhoneIcon />
            <Typography textAlign="center">Contact</Typography>
          </MenuItemWithIcon>
        </MenuItem>
        <MenuItem onClick={() => {
          onNavInstagram()
          handleCloseNavMenu()
        }}>
          <MenuItemWithIcon>
            <InstagramIcon />
            <Typography textAlign="center">Instagram</Typography>
          </MenuItemWithIcon>
        </MenuItem>
        <MenuItem onClick={() => {
          onNavFacebook()
          handleCloseNavMenu()
        }}>
          <MenuItemWithIcon>
            <FacebookIcon />
            <Typography textAlign="center">Facebook</Typography>
          </MenuItemWithIcon>
        </MenuItem >
      </Menu >
    </Box >
  )
}